import { JsonProperty, Optional } from 'json-ts-mapper';

export class DestinatairesAlerte {
  constructor (
    id?:number,
    envoiSms1?: boolean,
    envoiSms2?: boolean,
    envoiEmail?: boolean,
    idPersonne?:number
  ) {
    this.id = id;
    this.envoiSms1 = envoiSms1;
    this.envoiSms2 = envoiSms2;
    this.envoiEmail = envoiEmail;
    this.idPersonne = idPersonne;
  }

  @JsonProperty(Number)
  id:number;

  @JsonProperty(Boolean)
  @Optional
  envoiSms1: boolean;

  @JsonProperty(Boolean)
  @Optional
  envoiSms2: boolean;

  @JsonProperty(Boolean)
  @Optional
  envoiEmail: boolean;

  @JsonProperty(Number)
  @Optional
  idPersonne:number;
}
